import React from 'react';
import {GroupList} from "components/blood-group/GroupList";
import {Provider} from "components/blood-group/GroupContext";

export const BloodGroups = () => {

    return (
        <Provider>
            <GroupList/>
        </Provider>
    );
}
